import { render, staticRenderFns } from "./UrlClicksModal.vue?vue&type=template&id=bf795a78&scoped=true&lang=pug&"
import script from "./UrlClicksModal.vue?vue&type=script&lang=js&"
export * from "./UrlClicksModal.vue?vue&type=script&lang=js&"
import style0 from "./UrlClicksModal.vue?vue&type=style&index=0&id=bf795a78&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf795a78",
  null
  
)

/* custom blocks */
import block0 from "./UrlClicksModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports